import { api } from "./api";
import { getToken, isLoggedIn } from "../services/AuthStorage";
import { getGuestId } from "../utils/guest";

export const addToCart = async (cartData) => {
  try {
    const response = await api.post("/Cart/Add", cartData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCartItems = async () => {
  try {
    const headers = {};
    let url = "/Cart/GetList";

    if (isLoggedIn()) {
      headers["Authorization"] = `Bearer ${getToken()}`;
    } else {
      const guestId = getGuestId();
      url += `?guestId=${guestId}`;
    }

    const response = await api.get(url, { headers });
    return response.data;
  } catch (error) {
    const status = error?.response?.status;

    if (status === 404 || status === 500) {
      return [];
    }

    throw error;
  }
};

export const removeFromCart = async (cartId) => {
  try {
    const headers = {};
    let url = `/Cart/Delete/${cartId}`;

    if (isLoggedIn()) {
      headers["Authorization"] = `Bearer ${getToken()}`;
    } else {
      const guestId = getGuestId();
      url += `?guestId=${guestId}`;
    }

    const response = await api.delete(url, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const updateCartQuantity = async (cartId, quantity) => {
  try {
    const headers = {};
    const body = {
      cartId,
      quantity
    };

    if (isLoggedIn()) {
      headers["Authorization"] = `Bearer ${getToken()}`;
    } else {
      body.guestId = getGuestId();
    }

    const response = await api.put("/Cart/Update", body, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Xóa toàn bộ giỏ hàng
export const clearCart = async () => {
  try {
    const headers = {};
    let url = "/Cart/Clear";

    if (isLoggedIn()) {
      headers["Authorization"] = `Bearer ${getToken()}`;
    } else {
      const guestId = getGuestId();
      url += `?guestId=${guestId}`;
    }

    const response = await api.delete(url, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};
